export const countryCode = {
    AF: "Afghanistan",
    ZA: "Afrique du Sud",
    AX: "Îles Åland",
    AL: "Albanie",
    DZ: "Algérie",
    DE: "Allemagne",
    AD: "Andorre",
    AO: "Angola",
    AI: "Anguilla",
    AQ: "Antarctique",
    AG: "Antigua-et-Barbuda",
    SA: "Arabie saoudite",
    AR: "Argentine",
    AM: "Arménie",
    AW: "Aruba",
    AU: "Australie",
    AT: "Autriche",
    AZ: "Azerbaïdjan",
    BS: "Bahamas",
    BH: "Bahreïn",
    BD: "Bangladesh",
    BB: "Barbade",
    BY: "Biélorussie",
    BE: "Belgique",
    BZ: "Belize",
    BJ: "Bénin",
    BM: "Bermudes",
    BT: "Bhoutan",
    BO: "Bolivie",
    BQ: "Pays-Bas caribéens",
    BA: "Bosnie-Herzégovine",
    BW: "Botswana",
    BV: "Île Bouvet",
    BR: "Brésil",
    BN: "Brunei",
    BG: "Bulgarie",
    BF: "Burkina Faso",
    BI: "Burundi",
    KY: "Îles Caïmans",
    KH: "Cambodge",
    CM: "Cameroun",
    CA: "Canada",
    CV: "Cap-Vert",
    CF: "République centrafricaine",
    CL: "Chili",
    CN: "Chine",
    CX: "Île Christmas",
    CY: "Chypre",
    CC: "Îles Cocos",
    CO: "Colombie",
    KM: "Comores",
    CG: "République du Congo",
    CD: "République démocratique du Congo",
    CK: "Îles Cook",
    KR: "Corée du Sud",
    KP: "Corée du Nord",
    CR: "Costa Rica",
    CI: "Côte d'Ivoire",
    HR: "Croatie",
    CU: "Cuba",
    CW: "Curaçao",
    DK: "Danemark",
    DJ: "Djibouti",
    DO: "République dominicaine",
    DM: "Dominique",
    EG: "Égypte",
    SV: "Salvador",
    AE: "Émirats arabes unis",
    EC: "Équateur",
    ER: "Érythrée",
    ES: "Espagne",
    EE: "Estonie",
    US: "Etats-Unis",
    ET: "Éthiopie",
    FK: "Malouines",
    FO: "Îles Féroé",
    FJ: "Fidji",
    FI: "Finlande",
    FR: "France",
    GA: "Gabon",
    GM: "Gambie",
    GE: "Géorgie",
    GS: "Géorgie du Sud et les Îles Sandwich du Sud",
    GH: "Ghana",
    GI: "Gibraltar",
    GR: "Grèce",
    GD: "Grenade",
    GL: "Groenland",
    GP: "Guadeloupe",
    GU: "Guam",
    GT: "Guatemala",
    GG: "Guernesey",
    GN: "Guinée",
    GW: "Guinée-Bissau",
    GQ: "Guinée équatoriale",
    GY: "Guyana",
    GF: "Guyane",
    HT: "Haïti",
    HM: "Îles Heard-et-MacDonald",
    HN: "Honduras",
    HK: "Hong Kong",
    HU: "Hongrie",
    IM: "Île de Man",
    UM: "Îles mineures éloignées des États-Unis",
    VG: "Îles Vierges britanniques",
    VI: "Îles Vierges des États-Unis",
    IN: "Inde",
    ID: "Indonésie",
    IR: "Iran",
    IQ: "Irak",
    IE: "Irlande",
    IS: "Islande",
    IL: "Israël",
    IT: "Italie",
    JM: "Jamaïque",
    JP: "Japon",
    JE: "Jersey",
    JO: "Jordanie",
    KZ: "Kazakhstan",
    KE: "Kenya",
    KG: "Kirghizistan",
    KI: "Kiribati",
    KW: "Koweït",
    LA: "Laos",
    LS: "Lesotho",
    LV: "Lettonie",
    LB: "Liban",
    LR: "Liberia",
    LY: "Libye",
    LI: "Liechtenstein",
    LT: "Lituanie",
    LU: "Luxembourg",
    MO: "Macao",
    MK: "Macédoine",
    MG: "Madagascar",
    MY: "Malaisie",
    MW: "Malawi",
    MV: "Maldives",
    ML: "Mali",
    MT: "Malte",
    MP: "Îles Mariannes du Nord",
    MA: "Maroc",
    MH: "Îles Marshall",
    MQ: "Martinique",
    MU: "Maurice",
    MR: "Mauritanie",
    YT: "Mayotte",
    MX: "Mexico",
    FM: "Micronésie",
    MD: "Moldavie",
    MC: "Monaco",
    MN: "Mongolie",
    ME: "Monténégro",
    MS: "Montserrat",
    MZ: "Mozambique",
    MM: "Birmanie",
    NA: "Namibie",
    NR: "Nauru",
    NP: "Népal",
    NI: "Nicaragua",
    NE: "Niger",
    NG: "Nigeria",
    NU: "Niue",
    NF: "Île Norfolk",
    NO: "Norvège",
    NC: "Nouvelle-Calédonie",
    NZ: "Nouvelle-Zélande",
    IO: "Territoire britannique de l'océan Indien",
    OM: "Oman",
    UG: "Ouganda",
    UZ: "Ouzbékistan",
    PK: "Pakistan",
    PW: "Palaos",
    PS: "Palestine",
    PA: "Panama",
    PG: "Papouasie-Nouvelle-Guinée",
    PY: "Paraguay",
    NL: "Pays-Bas",
    PE: "Pérou",
    PH: "Philippines",
    PN: "Îles Pitcairn",
    PL: "Pologne",
    PF: "Polynésie française",
    PR: "Porto Rico",
    PT: "Portugal",
    QA: "Qatar",
    RE: "La Réunion",
    RO: "Roumanie",
    GB: "Royaume-Uni",
    RU: "Russie",
    RW: "Rwanda",
    EH: "République arabe sahraouie démocratique",
    BL: "Saint-Barthélemy",
    KN: "Saint-Christophe-et-Niévès",
    SM: "Saint-Marin",
    MF: "Saint-Martin",
    SX: "Sint Maarten",
    PM: "Saint-Pierre-et-Miquelon",
    VA: "Vatican",
    VC: "Saint-Vincent-et-les Grenadines",
    SH: "Sainte-Hélène, Ascension et Tristan da Cunha",
    LC: "Sainte-Lucie",
    SB: "Salomon",
    WS: "Samoa",
    AS: "Samoa américaines",
    ST: "Sao Tomé-et-Principe",
    SN: "Sénégal",
    RS: "Serbie",
    SC: "Seychelles",
    SL: "Sierra Leone",
    SG: "Singapour",
    SK: "Slovaquie",
    SI: "Slovénie",
    SO: "Somalie",
    SD: "Soudan",
    SS: "Soudan du Sud",
    LK: "Sri Lanka",
    SE: "Suède",
    CH: "Suisse",
    SR: "Suriname",
    SJ: "Svalbard et ile Jan Mayen",
    SZ: "Swaziland",
    SY: "Syrie",
    TJ: "Tadjikistan",
    TW: "Taïwan",
    TZ: "Tanzanie",
    TD: "Tchad",
    CZ: "République tchèque",
    TF: "Terres australes et antarctiques françaises",
    TH: "Thaïlande",
    TL: "Timor oriental",
    TG: "Togo",
    TK: "Tokelau",
    TO: "Tonga",
    TT: "Trinité-et-Tobago",
    TN: "Tunisie",
    TM: "Turkménistan",
    TC: "Îles Turques-et-Caïques",
    TR: "Turquie",
    TV: "Tuvalu",
    UA: "Ukraine",
    UY: "Uruguay",
    VU: "Vanuatu",
    VE: "Venezuela",
    VN: "Viêt Nam",
    WF: "Wallis-et-Futuna",
    YE: "Yémen",
    ZM: "Zambie",
    ZW: "Zimbabwe",
};

export const currency = {
    AED: "",
    ARS: "$",
    AUD: "$",
    BDT: "",
    BGN: "лв",
    BOB: "$b",
    BRL: "R$",
    CAD: "$",
    CDF: "",
    CFA: "",
    CFP: "",
    CHF: "CHF",
    CLP: "$",
    CNY: "¥",
    COP: "$",
    CRC: "₡",
    CZK: "Kč",
    DOP: "RD$",
    DZD: "",
    EGP: "£",
    ETB: "",
    EUR: "€",
    FJD: "$",
    GBP: "£",
    GHS: "",
    GNF: "",
    HTG: "",
    HUF: "Ft",
    IDR: "Rp",
    INR: "₹",
    JMD: "J$",
    JOD: "",
    JPY: "¥",
    KES: "",
    KHR: "៛",
    KZT: "лв",
    LBP: "£",
    MAD: "",
    MGA: "",
    MUR: "₨",
    MWK: "",
    MXN: "$",
    MYR: "RM",
    MZN: "MT",
    NGN: "₦",
    PAB: "B/.",
    PEN: "S/.",
    PHP: "₱",
    PLN: "zł",
    PYG: "Gs",
    RON: "lei",
    RSD: "Дин.",
    RUB: "₽",
    SAR: "﷼",
    SLL: "",
    THB: "฿",
    TND: "",
    TRY: "",
    TTD: "TT$",
    TWD: "NT$",
    TZS: "",
    UAH: "₴",
    UGX: "",
    USD: "$",
    UYU: "$U",
    VEF: "Bs",
    VND: "₫",
    XOF: "",
    ZAR: "S",
    ZMW: "",
    ZWD: "Z$",
};

export const EVENT = {
    CALL_CLICKED: "callClicked",
    DETAIL_CLICKED: "detailClicked",
    GEOLOCATION_CLICKED: "geolocationClicked",
    GO_CLICKED: "goClicked",
    MORE_INFORMATION_CLICKED: "moreInformationClicked",
    NAVIGATION_CLICKED: "navigationClicked",
    SEARCH_CLICKED: "searchClicked",
    SEND_CLICKED: "sendClicked",
    STORE_CLICKED: "storeClicked",
    PRINT_LIST_CLICKED: "printListClicked",
    SHOW_ITINARY_PANEL: "showItinaryPanel",
};

export const TAGS = {
    OPEN_24_7: ["2424openinghours", "2424shop", "fuelautomat"],
};

export const UNIVERSES = {
    BRAND: "brand",
};
export const boundsTW = {
    south: 21.476345,
    north: 25.703118,
    east: 122.570872,
    west: 119.104351,
};
export const categories = {
    CAR_WASH: "CAR_WASH",
};
export const statuses = ["OPEN", "TEMPORARY_CLOSED"];

export const FILTERS_LOOKUP = [
    { code: "ENERGIES", type: "CATEGORIES" },
    { code: "CAR_WASH", type: "CATEGORIES" },
    { code: "FOOD", type: "CATEGORIES" },
    { code: "SERVICES", type: "CATEGORIES" },
    { code: "SHOP", type: "CATEGORIES" },
    { code: "Offers", type: "OFFERS" },
    { code: "LOYALTY", type: "CATEGORIES" },
    { code: "EQUIPMENT", type: "CATEGORIES" },
    { code: "LUBRICANTS", type: "CATEGORIES" },
    { code: "TECHNICAL_BAY", type: "CATEGORIES" },
    { code: "VENDING_MACHINE", type: "CATEGORIES" },
    { code: "UTILITIES", type: "CATEGORIES" },
    { code: "TRUCK_SERVICES", type: "CATEGORIES" },
    { code: "means_of_payment", type: "MOP" },
    { code: "Brands", type: "BRANDS" },
];
export const BRAND_ICON_KEY = {
    TOTAL: "fueling",
    ACCESS: "fueling",
    ELAN: "fueling",
    TWASH: "wash",
    AS24: "default",
    ARS: "garage",
    RTS: "garage",
    QAS: "garage",
    HMS: "garage",
    DIS: "garage",
};
export const MOBILE_BREAKPOINT = 768;

export const ALLOWED_BUSINESSES = ["retail", "general_trade", "ev", "lubricant", "aviation"];
// Businesses whose hot-data call needs business_type (uppercased; the API is case-sensitive, #205).
export const HOT_DATA_BUSINESSES = ["retail", "general_trade"];

export const POI_TYPES = {
    FUELING: "FUELING",
    EV: "EV",
    WASH: "WASH",
    GARAGE: "GARAGE",
    DISTRIBUTOR: "DISTRIBUTOR",
    AIRPORT: "AIRPORT",
    AIRFIELD: "AIRFIELD",
};

// Autocomplete dedup tiebreaker when two stations share a name.
// Lower number = higher priority. Keyed by selected business.
// Retail/general_trade: FUELING > EV > Others > WASH (STE/Theo, April 2026).
// Lubricant: GARAGE > DISTRIBUTOR. Aviation: AIRPORT > AIRFIELD.
export const POI_TYPE_PRIORITY_BY_BUSINESS = {
    all: {
        [POI_TYPES.FUELING]: 1,
        [POI_TYPES.EV]: 2,
        [POI_TYPES.GARAGE]: 4,
        [POI_TYPES.DISTRIBUTOR]: 5,
        [POI_TYPES.WASH]: 6,
    },
    retail: {
        [POI_TYPES.FUELING]: 1,
        [POI_TYPES.EV]: 2,
        [POI_TYPES.WASH]: 3,
    },
    general_trade: {
        [POI_TYPES.FUELING]: 1,
        [POI_TYPES.EV]: 2,
        [POI_TYPES.WASH]: 3,
    },
    ev: {
        [POI_TYPES.EV]: 1,
    },
    lubricant: {
        [POI_TYPES.GARAGE]: 1,
        [POI_TYPES.DISTRIBUTOR]: 2,
    },
    aviation: {
        [POI_TYPES.AIRPORT]: 1,
        [POI_TYPES.AIRFIELD]: 2,
    },
};
// Priority applied to a poiType not listed in the selected business's map.
// In "all", sits between EV and GARAGE ("Others" per retail spec).
export const POI_TYPE_PRIORITY_DEFAULT = 3;

// Default poiTypes for an embed that omits the option, keyed by the business
// option. Returns the union of POI_TYPE_PRIORITY_BY_BUSINESS keys across the
// (comma-separated) businesses; falls back to "all" when business is absent or
// unknown. The caller still validates results against the live config types.
export function defaultPoiTypesForBusiness(businessOption) {
    const businesses =
        typeof businessOption === "string"
            ? businessOption
                  .toLowerCase()
                  .split(",")
                  .map((business) => business.trim())
                  .filter(Boolean)
            : [];
    const keys = businesses.length > 0 ? businesses : ["all"];
    const types = new Set();
    for (const key of keys) {
        const priorityMap = POI_TYPE_PRIORITY_BY_BUSINESS[key] ?? POI_TYPE_PRIORITY_BY_BUSINESS.all;
        for (const type of Object.keys(priorityMap)) {
            types.add(type);
        }
    }
    return [...types];
}
